import axios from "axios"
export const axiosClient=axios.create({
    baseURL:"https://test-agpu.onrender.com",
    // baseURL:"http://localhost:3001",
    headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
     }
});
